<template>
  <init-loader v-if="initLoading"></init-loader>
  <div v-else>
    <v-card>
      <v-toolbar dense dard flat>
        <v-toolbar-title>페이지 현황</v-toolbar-title>
        <v-spacer/>
        <v-btn color="success" text to="/page/index"><v-icon left>mdi-arrow-right-circle</v-icon> 전체보기</v-btn>
      </v-toolbar>
      <page-index category="page" :limit="3"></page-index>
    </v-card>
    <v-sheet height="8"></v-sheet>
    <v-card>
      <v-toolbar dense dard flat>
        <v-toolbar-title>게시판 현황</v-toolbar-title>
        <v-spacer/>
        <v-btn color="success" text to="/board/index"><v-icon left>mdi-arrow-right-circle</v-icon> 전체보기</v-btn>
      </v-toolbar>
      <board-index category="board" :limit="3"></board-index>
    </v-card>
  </div>
</template>
<script>
import InitLoader from './skeleton'
import PageIndex from '@/views/page/index'
import BoardIndex from '@/views/board/index'
import delay from 'delay'

export default {
  components: { InitLoader, PageIndex, BoardIndex },
  data () {
    return {
      initLoading: false
    }
  },
  created () {
    // this.initLoad()
  },
  methods: {
    initLoad () {
      this.initLoading = true
      delay(1000).then(() => { this.initLoading = false })
    }
  }

}
</script>
